import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const OtomatikPergolaPage = () => {
  useEffect(() => {
    document.title = 'Otomatik Pergola Tente - İzmir Tente Tamir | Akıllı Pergola Sistemleri';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde otomatik pergola tente montajı ve tamiri. Motorlu, uzaktan kumandalı modern pergola çözümleri. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Bioklimatik Pergola Tente', link: '/hizmetler/bioklimatik-pergola-tente' },
    { title: 'Kasetli Tente', link: '/hizmetler/kasetli-tente' },
    { title: 'Zip Perde Tente', link: '/hizmetler/zip-perde-tente' },
    { title: 'Manuel Motorlu Tente Servisi', link: '/hizmetler/manuel-motorlu-tente-servisi' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-20 md:pt-24">
        <div className="w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/0e5e823fb30b26c18b739ea169deefe2.jpg"
            alt="Otomatik Pergola Tente"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6 mt-8">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Otomatik Pergola Tente</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Otomatik Pergola Tente
              </h1>
              
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                Otomatik pergola tente, modern teknoloji ile konforun buluştuğu, motorlu ve uzaktan kumandalı gölgelendirme sistemidir. Tek tuşla açılıp kapanan bu sistem, bahçe, teras ve dış mekanlarınızda maksimum konfor sağlar. İzmir Tente Tamir olarak, otomatik pergola montajı ve tamir hizmetleri sunuyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Otomatik Pergola Tente Nedir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Otomatik pergola tente, elektrik motoru ile çalışan ve uzaktan kumanda veya akıllı telefon uygulaması ile kontrol edilebilen pergola sistemidir. Sabit bir çerçeve üzerine monte edilen kumaş veya lamel sistem, motor yardımıyla açılıp kapanır. Manuel çaba gerektirmeden konforlu kullanım sunar.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Otomatik Pergola Özellikleri</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Motorlu Sistem:</strong> Güçlü ve sessiz elektrik motoru</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzaktan Kumanda:</strong> Kablosuz kumanda ile kolay kontrol</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Akıllı Kontrol:</strong> Mobil uygulama ile uzaktan yönetim</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Sensör Desteği:</strong> Rüzgar, yağmur ve güneş sensörleri</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Dayanıklı Yapı:</strong> Alüminyum veya çelik konstrüksiyon</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>LED Aydınlatma:</strong> Entegre ışık sistemleri</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Su Geçirmez Kumaş:</strong> Yağmura karşı koruma</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Otomatik Pergola Türleri</h2>
              
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Kumaş Kapaklı Otomatik Pergola</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Dayanıklı ve su geçirmez kumaş ile kaplı, motorlu açılıp kapanan sistem. Geniş renk ve desen seçenekleri sunar.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Lamel Kapaklı Otomatik Pergola</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Alüminyum lamellerden oluşan, açılabilir ve döndürülebilir sistem. Havalandırma ve gölgelendirme kontrolü sağlar.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Cam Kapaklı Otomatik Pergola</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Cam panellerle kapatılabilen, kış bahçesi gibi kullanılabilen lüks pergola sistemi.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Otomatik Pergola Avantajları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kullanım Kolaylığı:</strong> Tek tuşla açılıp kapanır</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Konfor:</strong> Fiziksel güç gerektirmez</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Akıllı Otomasyon:</strong> Sensörler ile otomatik çalışma</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Geniş Alan Kapasitesi:</strong> Büyük alanları kolayca kapatır</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Modern Tasarım:</strong> Estetik ve şık görünüm</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Değer Artışı:</strong> Mülkünüzün değerini yükseltir</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Kullanım Alanları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Villa ve rezidans bahçeleri</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Teras ve balkon alanları</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Cafe ve restoran dış mekanları</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Otel ve tatil köyü havuz başları</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700">Ticari işletme dış alanları</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Hizmetlerimiz</h2>
              
              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Otomatik Pergola Montajı</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Profesyonel ekibimiz, alanınıza uygun otomatik pergola sistemini tasarlıyor ve monte ediyoruz. Ölçüm, proje, montaj ve devreye alma hizmetlerini sunuyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Otomatik Pergola Tamiri</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Motor arızaları, kumanda sorunları, sensör problemleri ve mekanik aksaklıkları gideriyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">Bakım ve Servis</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Düzenli bakım hizmetleri ile pergola sisteminizin uzun ömürlü olmasını sağlıyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Neden İzmir Tente Tamir?</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uzman Ekip:</strong> Otomatik pergola konusunda deneyimli teknisyenlerimiz var</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kaliteli Ürünler:</strong> Avrupa standartlarında pergola sistemleri</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Profesyonel Montaj:</strong> Hızlı ve özenli kurulum</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Garanti:</strong> Tüm işlemlerimiz garanti kapsamındadır</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mt-8">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-sm md:text-base text-gray-700 mb-6">
                  Otomatik pergola montajı veya tamiri için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default OtomatikPergolaPage;